import { Tariflist } from "./module/tariflist";
import { Articlelist } from "./module/articlelist";
import { ReloadManager } from "./reloadManager";
import { Offerboxer } from "./module/angebotsboxer";
import { SlDrawer } from "@shoelace-style/shoelace/shoelace";
import { notNull } from "../../../../vendor/plugins/clxMobileNetPortable/assets/responsive/js/common/assert";

export class CmsmoduleInit {
    private readonly reloadManager: ReloadManager;

    constructor(viewRoot: HTMLElement) {
        this.reloadManager = new ReloadManager();
        this.initCmsModule(viewRoot);
        this.registerEventListenersForFields(viewRoot);
    }
    private initCmsModule(viewRoot: HTMLElement) {
        new Tariflist(viewRoot);
        new Offerboxer(viewRoot);

        const articlelist = new Articlelist(viewRoot);
        articlelist.init();
    }

    private registerEventListenersForFields(viewRoot: HTMLElement) {
        // Event-Listener fuer `change` auf `select`- und `input`-Elementen mit der Klasse `cmsReloadModule`  (z.b. der Preisslider ist ein Change)
        viewRoot
            .querySelectorAll<HTMLElement>(
                "select.cmsReloadModule, input.cmsReloadModule",
            )
            .forEach((element) => {
                element.addEventListener("change", (event) => {
                    const result = this.reloadManager.cmsReloadModule(event);

                    this.openFilterDrawerAfterReload(result, element);
                });
            });

        // Event-Listener fuer `click` auf `input`-Elementen mit der Klasse `cmsReloadModule`
        viewRoot
            .querySelectorAll<HTMLElement>("input.cmsReloadModule")
            .forEach((element) => {
                element.addEventListener("click", (event) => {
                    const result = this.reloadManager.cmsReloadModule(event);

                    this.openFilterDrawerAfterReload(result, element);
                });
            });
    }

    private openFilterDrawerAfterReload(
        result: Promise<HTMLElement> | null,
        target: HTMLElement,
    ): void {
        const elementOnLayer = target.closest("sl-drawer") as SlDrawer | null;
        if (elementOnLayer === null) {
            return;
        }

        if (result === null) {
            return;
        }

        result.then((moduleRoot) => {
            new Articlelist(moduleRoot).openDrawer(
                notNull(moduleRoot.getAttribute("data-module-id")),
            );
        });
    }
}
